<template>
  <div class="card mb-4 flex flex-row relative scroll-mt-14 p-2 sm:p-4 min-w-0 overflow-x-hidden" :class="goalCardClass" ref="goalel">
    <div :class="{'flex-shrink-0 w-9 sm:w-10 pt-2 sm:pt-4 pl-2 sm:pl-4 flex items-start justify-start': !editable, 'hidden': editable}">
      <font-awesome-icon icon="fa-bullseye"
        class="text-xl sm:text-2xl text-[var(--color-orange)]" />
    </div>
    <div class="ml-2 sm:ml-4 md:pr-4 md:flex md:flex-col flex-1 min-w-0">
      <div class="flex flex-wrap flex-col w-full items-start mb-2 md:ml-1">
        <div class="w-full min-w-0">
          <label v-if="this.editable" class="text-[var(--color-disabled)] ml-1 mb-1 text-base sm:text-xl">
            {{ $t('PersonalGoals.qGoalName') }}
          </label>
          <Textarea v-model="this.goalName" id="goal-name" :disabled="!editable" maxlength="150"
            class="w-full max-w-full h-24 py-2 px-3 sm:px-4 text-sm sm:text-base mt-2 sm:mt-4 mr-0 sm:mr-3 rounded-md bg-[var(--color-light)]"
            :class="{'hidden': !this.editable}"/>
        </div>
        <label v-if="!this.editable" class="my-1 ml-1 sm:ml-2 text-base sm:text-xl break-words">
          {{ this.goalName }}
        </label>
        <div class="flex flex-row flex-wrap gap-2 mt-2">
          <div class="flex flex-row text-white bg-[var(--color-orange)] rounded-md w-max min-h-8 h-9 p-2 sm:p-3
            items-center text-sm sm:text-base shrink-0"
            @click="toggleCalendar">
            <font-awesome-icon icon="fa-calendar" class="shrink-0"/>
            <p class="whitespace-nowrap p-1">
                {{ timeRubberDate }}</p>
          </div>
          <div v-if="!this.editable" class="text-white bg-[var(--color-orange)] rounded-md
            w-max min-h-8 h-9 px-2 sm:px-3 pt-1 items-center text-sm sm:text-base shrink-0">
            <label class="break-words">{{ this.goalType }}</label>
          </div>
          <div v-else class="w-full sm:w-auto min-w-0">
            <Select v-model="goalType" :options="goalsDropdown" optionLabel="name"
              optionValue="value" class="w-full sm:w-36 bg-[var(--color-light)] h-9 max-w-full" />
          </div>
        </div>
      </div>
        <edit-kss-calendar-component v-if="this.editable && this.showCalendar"
                                   :editable="this.editable" :initialDate="selectedDate"
                                   @updateDate="updateSelectedDate" />

      <div class="w-full md:ml-1 grid grid-cols-1 lg:grid-cols-2 gap-3 sm:gap-4 mt-2">
        <PersonalGoalsQnAComponent :editable="this.editable"
                                   v-for="qna in qnaSet"
                                   :key="qna._id"
                                   :qna="qna"/>
        <div class="mt-4 w-full min-w-0 lg:col-span-2" v-if="this.editable && this.goalType === 'Habit'">
          <label class="text-[var(--color-disabled)] ml-1 my-2 text-base sm:text-xl">
            {{ $t('PersonalGoals.setReminder') }}
          </label>
          <div class="card w-full p-2 sm:p-4" id="div_runtime">
            <div class="flex flex-row justify-center items-center">
              <vee-field v-model="time" type="time" class="text-2xl sm:text-3xl font-bold"
               name="start-time" id="input_cal-time"/>
            </div>
            <div id="drop_event">
              <div class="flex items-center justify-center flex-wrap mt-4 sm:mt-6 gap-1" id="seven_days">
                <label id="day" v-for="(day, index) in days" :key="day.name"
                  @click="selectDay(index)" class="flex relative text-xs sm:text-sm w-fit">
                  <div class="flex p-2 sm:p-4 rounded-lg m-0 cursor-pointer border-[1px]
                    border-[var(--color-light-grey)]"
        :class="{'text-[var(--color-orange)] border-[var(--color-orange)] bg-[var(--color-bisque)]'
                     : day.isSelected}">
                    <span :class="{'font-semibold': day.isSelected}">
                        {{ $t('PersonalGoals.daysShort.' + day.rSchName) }}</span>
                  </div>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="this.editable" class="w-full pt-4 sm:pt-8 box-border flex flex-col-reverse sm:flex-row justify-end gap-2 sm:gap-0">
        <Button class="text-red-600 bg-none rounded-full w-full sm:w-fit min-h-10 my-0 mx-0 sm:mx-4 px-4 py-2 text-sm sm:text-base
        hover:text-red-700" :label="this.$t('PersonalGoals.deleteGoalButton')"
          v-if="editable" @click.prevent="deleteGoal"
                id="btn_delete" icon="pi pi-trash" unstyled/>
        <Button class="btn-primary-accent w-full sm:w-fit min-h-fit my-0 mx-0 sm:mx-4 px-6 py-2 text-sm sm:text-base"
            :disabled="editable === false"
            :class="editable === false && 'disabled'" @click.prevent="updateGoal"
                id="btn_update" unstyled>
            {{ $t('PersonalGoals.update') }}
        </Button>
      </div>
    </div>
    <div class="absolute flex justify-end text-[var(--color-disabled)] right-2 top-2 sm:right-3 sm:top-3 w-7 h-7 sm:w-8 sm:h-8">
      <div class="flex flex-row items-center cursor-pointer mx-3">
        <div v-if="$route.path === '/personal-goals' && this.status === 'active'"
          class="text-xl mr-3 hover:text-[var(--color-orange)]" @click.prevent="toggleEditable"
          id="icon_pen">
          <i>
            <font-awesome-icon icon="fa-pen"/>
          </i>
        </div>
        <Checkbox v-model='checked' binary @change="goalStatusChange" size="large"
          id="chk_markGoal"/>
      </div>
    </div>
    <PersonalGoalFeedbackOverlayComponent v-if="showDialog"
        v-model:visible="showDialog" @confirmed="onFeedbackConfirmed"
        :data="notification"></PersonalGoalFeedbackOverlayComponent>
  </div>
</template>
<script>
import PersonalGoalsQnAComponent
  from '@/components/Home/PersonalGoalsComponent/PersonalGoalsQnAComponent.vue';
import EditKssCalendarComponent
  from '@/components/Home/KssCreator/KssEditComponents/EditKssCalendarComponent.vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import {
  Button,
  Checkbox,
  Select,
  Textarea,
} from 'primevue';
import { ref } from 'vue';
import PersonalGoalFeedbackOverlayComponent from '../Shared/FrontendOverlays/PersonalGoalFeedbackOverlayComponent.vue';
import { getFeatureDisplayNameOrFallback } from '@/utils/featureDisplay';

export default {
  name: 'GoalComponent',
  props: ['goal'],
  components: {
    FontAwesomeIcon,
    EditKssCalendarComponent,
    PersonalGoalsQnAComponent,
    Checkbox,
    Button,
    Textarea,
    Select,
    PersonalGoalFeedbackOverlayComponent,
  },
  data() {
    return {
      selectedDate: new Date(this.goal.goalDate),
      editable: false,
      maxLimit: this.$store.getters.getPersonalGoalsMaxLimit,
      popupMessage: this.$t('PersonalGoalsComponent.popup.deleteMessage'),
      deleteButtonText: this.$t('PersonalGoalsComponent.popup.deleteButton'),
      cancelButtonText: this.$t('PersonalGoalsComponent.popup.cancelButton'),
      showPopup: false,
      showCalendar: false,
      goalName: this.goal.goalName,
      goalType: this.goal.goalType,
      goalDate: this.goal.goalDate,
      status: this.goal.status,
      days: this.goal.reminderTime.days.length > 0 ? this.goal.reminderTime.days
        : this.initRecurringDays([]),
      time: this.goal.reminderTime.time ?? '12:00',
      checked: (this.goal.status === 'completed'),
      goalsDropdown: ref([
        { name: this.$t('PersonalGoals.goalType.habit'), value: this.$t('PersonalGoals.goalType.habit') },
        { name: this.$t('PersonalGoals.goalType.mindset'), value: this.$t('PersonalGoals.goalType.mindset') },
        { name: this.$t('PersonalGoals.goalType.reflection'), value: this.$t('PersonalGoals.goalType.reflection') },
        { name: this.$t('PersonalGoals.goalType.other'), value: this.$t('PersonalGoals.goalType.other') },
      ]),
      showDialog: false,
      notification: {},
    };
  },
  watch: {
    goalType(newGoalType) {
      this.goalType = newGoalType;
    },
  },
  computed: {
    timeRubberDate() {
      const goalDateString = new Date(this.goalDate);
      return `${(`0${goalDateString.getDate()}`).slice(-2)}.${(`0${goalDateString.getMonth() + 1}`).slice(-2)}.${goalDateString.getFullYear()}`;
    },
    qnaSet() {
      return this.goal.questionAndAnswer;
    },
    goalCardClass() {
      return (this.status === 'active') ? '' : 'card-inactive';
    },
    featureNamePersonalGoals() {
      return getFeatureDisplayNameOrFallback(
        this.$store,
        'personalGoals',
        this.$t('FallbackTexts.personalGoals'),
        this.$i18n?.locale,
      );
    },
  },
  methods: {
    updateSelectedDate(date) {
      this.goalDate = date;
      this.toggleCalendar();
    },
    async updateGoal() {
      if (this.checkForErrors()) {
        return;
      }
      const updatedValue = this.$store.getters.getGoalUpdateObject;
      const updatedData = this.qnaSet.map((ele) => {
        if (Object.prototype.hasOwnProperty.call(updatedValue, ele.questionKeyword)) {
          return { ...ele, answer: updatedValue[ele.questionKeyword] };
        }
        return ele;
      });
      const data = {
        goalId: this.goal._id,
        goalName: this.goalName,
        goalType: this.goalType,
        goalDate: this.goalDate,
        creationDate: this.goal.creationDate,
        questionAndAnswer: updatedData,
        reminderTime: {
          time: this.time,
          days: this.days,
        },
      };
      await this.$store.dispatch('updatePersonalGoal', data);
      this.$toast.add({
        severity: 'success',
        summary: this.$t('PersonalGoals.updateMsg', { text: this.featureNamePersonalGoals }),
        detail: '',
        life: 3000,
      });
    },
    checkForErrors() {
      let hasError = false;
      if (this.goalName === '') {
        this.$toast.add({
          severity: 'error',
          summary: this.$t('PersonalGoals.enterName'),
          detail: '',
          life: 3000,
        });
        hasError = true;
      }
      if (this.goalType === '') {
        this.$toast.add({
          severity: 'error',
          summary: this.$t('PersonalGoals.selectGoal'),
          detail: '',
          life: 3000,
        });
        hasError = true;
      }
      const currentDate = new Date();
      if (this.goalDate - currentDate < 0) {
        this.$toast.add({
          severity: 'error',
          summary: this.$t('PersonalGoals.incorrectDate'),
          detail: '',
          life: 3000,
        });
        hasError = true;
      }
      return hasError;
    },
    toggleEditable() {
      this.editable = !this.editable;
      if (this.editable) {
        setTimeout(() => this.scrollToElement(), 150);
      }
    },
    // reverting completed goal to incomplete
    async uncheckedGoal() {
      const activeGoals = this.$store.getters.getActiveGoalsCount;
      if (activeGoals >= this.maxLimit) {
        this.$toast.add({
          severity: 'error',
          summary: this.$t('PersonalGoals.toast.maximumGoalsMessage'),
          detail: '',
          life: 3000,
        });
        return;
      }
      await this.$store.dispatch('changeGoalStatus', {
        id: this.goal?._id,
        status: 'active',
      });
      this.$store.commit('setActiveGoalsCount', (activeGoals + 1));
    },
    async checkedGoal() {
      this.notification = {
        goalId: this.goal?._id,
      };
      this.showDialog = true;
    },
    async onFeedbackConfirmed() {
      this.showDialog = false;
      try {
        await this.$store.dispatch('changeGoalStatus', {
          id: this.goal?._id,
          status: 'completed',
        });
        /* this.$store.commit('addFrontendOverlay', {
          id: Math.random(),
          type: 'personalGoalFeedback',
          goalId: this.goal?._id,
        }); */
        this.$store.commit('setActiveGoalsCount', (this.$store.getters.getActiveGoalsCount - 1));
      } catch (error) {
        this.$toast.add({
          severity: 'error',
          summary: 'Error!',
          detail: '',
          life: 3000,
        });
      }
    },
    async onPopupConfirm() {
      try {
        await this.$store.dispatch('changeGoalStatus', {
          id: this.goal?._id,
          status: 'deleted',
        });
      } catch (error) {
        this.$toast.add({
          severity: 'error',
          summary: 'Error!',
          detail: '',
          life: 3000,
        });
      }
    },
    toggleCalendar() {
      this.showCalendar = !this.showCalendar;
    },
    deleteGoal() {
      this.$confirm.require({
        message: this.popupMessage,
        header: 'Confirmation',
        icon: 'pi pi-exclamation-triangle',
        rejectProps: {
          label: this.cancelButtonText,
          severity: 'secondary',
          outlined: true,
        },
        acceptProps: {
          label: this.deleteButtonText,
        },
        accept: this.onPopupConfirm,
        reject: this.onPopupCancel,
      });
      // this.showPopup = true;
    },
    onPopupCancel() {
      this.showPopup = false;
    },
    scrollToElement() {
      const el = this.$refs.goalel;

      if (el) {
        // Use el.scrollIntoView() to instantly scroll to the element
        el.scrollIntoView({ behavior: 'smooth' });
      }
    },
    selectDay(index) {
      this.days[index].isSelected = !this.days[index].isSelected;
    },
    initRecurringDays(byDays) {
      return [
        {
          rSchName: 'MO',
          isSelected: byDays.includes('MO'),
        },
        {
          rSchName: 'TU',
          isSelected: byDays.includes('TU'),
        },
        {
          rSchName: 'WE',
          isSelected: byDays.includes('WE'),
        },
        {
          rSchName: 'TH',
          isSelected: byDays.includes('TH'),
        },
        {
          rSchName: 'FR',
          isSelected: byDays.includes('FR'),
        },
        {
          rSchName: 'SA',
          isSelected: byDays.includes('SA'),
        },
        {
          rSchName: 'SU',
          isSelected: byDays.includes('SU'),
        },
      ];
    },
    goalStatusChange() {
      if (this.checked) {
        this.checkedGoal();
      } else {
        this.uncheckedGoal();
      }
      // this.checked = !this.checked;
    },
  },
  unmounted() {
    this.$store.commit('removeGoalsObject');
  },
  mounted() {
    this.checked = (this.goal.status === 'completed');
  },
};

</script>
